import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Modal, { BaseModalBackground } from 'styled-react-modal';
import { Route, NavLink as NavLinkRouter, withRouter } from 'react-router-dom';
import moment from 'moment';

import { GET_LAB_ORDERS_LIST } from '../graphql';
import SpinLoader from '../components/SpinLoader';
import { Query } from 'react-apollo';
import styled from 'styled-components';
import { LabOrderHiddenForm } from './labOrders/LabOrderHiddenForm';
import withSession from '../lib/withSession';

const Inner = styled(Flex)`
  max-width: 750px;
  height: 100vh;
  background: rgb(253, 245, 242);
  overflow-y: auto;
  box-shadow: 5px 5px 30px 0px rgba(78, 101, 138, 0.35);
  @media screen and (min-width: 52em) {
    padding: 24px;
  }
`;

const BackButton = styled.div`
  background: rgba(180, 205, 244, 0.5);
  width: 100%;
  color: #333;
  padding: 6px 12px;
  @media screen and (min-width: 52em) {
    display: none;
  }
`;
const BackButtonDesktop = styled.div`
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const FlexDesktop = styled(Flex)`
  display: flex;
  @media screen and (max-width: 52em) {
    display: none;
  }
`;
const FlexMobile = styled(Flex)`
  display: flex;
  @media screen and (min-width: 52em) {
    display: none;
  }
`;
const DetailContainer = styled(Flex)`
  display: none;
  overflow-y: auto;
  &.selected {
    right: 0;
    top: 0;
    position: fixed;
    height: 100vh;
    z-index: 10;
    width: 100vw;
    max-width: 100vw;
    display: flex;
    justify-content: flex-end;
    background: transparent;
    backdrop-filter: blur(2px);
  }

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

export const DateMobile = styled(Text)`
  display: none;

  @media screen and (max-width: 52em) {
    font-size: 18px;
    font-weight: 300;
    display: initial;
    margin-bottom: 12px;
  }
`;

const iconStyle = {
  width: '20px',
  height: '20px',
  background: '#FFFFFF',
  border: '3px solid #BCFFEB',
  margin: '10px',
  boxShadow: 'initial',
};
const SpecialModalBackground = styled(BaseModalBackground)`
  backdrop-filter: blur(5px);
`;

const NavLink = styled(NavLinkRouter)`
  text-decoration: none;
`;

const ContentResults = ({ lab, date, canViewDoc }) => {
  const [isShowDoc, setIsShowDoc] = useState(false);
  const handleClose = () => {
    setIsShowDoc(false);
  };
  return (
    <>
      <Flex
        flexDirection={'column'}
        style={{ textDecoration: 'none', cursor: canViewDoc ? 'pointer' : '' }}
        onClick={() => {
          if (!canViewDoc) return;

          setIsShowDoc(true);
        }}
      >
        <DateMobile>{date}</DateMobile>
        <Flex flexDirection={['column', 'row']}>
          <Text flex={1} className="vertical-timeline-element-title" fontWeight={600}>
            Lab Order
          </Text>
          {canViewDoc && (
            <Flex justifyContent={['flex-start', 'center']} alignItems={'center'}>
              <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.2678 4.61557C14.391 4.73881 14.4609 4.90519 14.4609 5.07979V17.7474C14.4609 18.111 14.1671 18.4047 13.8036 18.4047H0.657312C0.293736 18.4047 0 18.111 0 17.7474V0.657312C0 0.293736 0.293736 0 0.657312 0H9.38108C9.55568 0 9.72411 0.0698395 9.84736 0.193086L14.2678 4.61557ZM12.9449 5.38174L9.07913 1.51593V5.38174H12.9449ZM9.72042 11.7753C9.4086 11.7651 9.07707 11.7891 8.70056 11.8361C8.20141 11.5282 7.86536 11.1053 7.62667 10.4839L7.64865 10.394L7.67412 10.2876C7.76245 9.91514 7.8099 9.64339 7.82407 9.36937C7.83475 9.16252 7.82325 8.9717 7.78648 8.79484C7.7187 8.41298 7.44858 8.1897 7.10822 8.17594C6.79086 8.163 6.49918 8.34027 6.42461 8.6149C6.30321 9.059 6.37429 9.64339 6.63166 10.64C6.30383 11.4216 5.87062 12.338 5.57997 12.849C5.19195 13.0491 4.88979 13.2311 4.6359 13.4328C4.30108 13.6992 4.09197 13.973 4.03446 14.2606C4.00652 14.3939 4.04863 14.5681 4.14456 14.7109C4.25343 14.8727 4.41734 14.9779 4.61392 14.9931C5.10999 15.0315 5.71964 14.52 6.39277 13.365C6.46035 13.3424 6.53184 13.3186 6.61913 13.289L6.86357 13.2064C7.01825 13.1543 7.1304 13.1169 7.24132 13.0809C7.72198 12.9244 8.08556 12.8256 8.41627 12.7693C8.991 13.077 9.6553 13.2787 10.1027 13.2787C10.472 13.2787 10.7216 13.0873 10.8118 12.786C10.8908 12.5214 10.8282 12.2145 10.6581 12.0448C10.4823 11.8721 10.159 11.7895 9.72042 11.7753ZM4.62645 14.4132V14.4058L4.62912 14.3988C4.65918 14.3211 4.69776 14.247 4.74415 14.1778C4.83207 14.0427 4.95305 13.9005 5.103 13.7491C5.18352 13.668 5.26733 13.5889 5.36572 13.5002C5.3877 13.4804 5.5282 13.3554 5.55449 13.3307L5.78394 13.1171L5.61714 13.3827C5.36408 13.7861 5.13525 14.0765 4.93929 14.2659C4.86719 14.3358 4.80372 14.3871 4.75237 14.4202C4.73541 14.4315 4.71747 14.4413 4.69876 14.4494C4.69033 14.4529 4.68294 14.4549 4.67554 14.4555C4.66774 14.4565 4.65981 14.4555 4.65254 14.4524C4.64481 14.4492 4.63821 14.4438 4.63356 14.4368C4.62892 14.4298 4.62645 14.4216 4.62645 14.4132ZM7.21339 9.92952L7.16696 10.0117L7.13821 9.92172C7.07453 9.7198 7.0277 9.41559 7.01475 9.14116C6.99997 8.82894 7.02482 8.6416 7.12342 8.6416C7.26186 8.6416 7.32533 8.86345 7.33026 9.19724C7.33478 9.49056 7.28877 9.7958 7.21339 9.92952ZM7.09404 11.1304L7.12547 11.0472L7.1684 11.1252C7.40853 11.5615 7.72013 11.9255 8.06276 12.1792L8.1367 12.2338L8.04653 12.2523C7.71109 12.3217 7.39867 12.4261 6.97141 12.5984C7.01599 12.5803 6.52732 12.7804 6.40366 12.8279L6.29582 12.8691L6.35333 12.7689C6.60702 12.3273 6.84159 11.7969 7.09404 11.1304ZM10.3317 12.6968C10.1703 12.7605 9.82271 12.7036 9.21079 12.4423L9.0555 12.3762L9.22394 12.3638C9.70255 12.3283 10.0415 12.3546 10.2391 12.4269C10.3233 12.4577 10.3794 12.4965 10.4042 12.5409C10.4173 12.5619 10.4217 12.5872 10.4165 12.6114C10.4113 12.6356 10.3969 12.6568 10.3763 12.6705C10.3632 12.682 10.3481 12.6909 10.3317 12.6968Z"
                  fill="#344F7A"
                />
              </svg>
              <Text ml={3} fontSize={'14px'} style={{ textDecoration: 'underline' }} fontWeight={300}>
                View Document
              </Text>
            </Flex>
          )}
        </Flex>
        <ul>
          {lab.ordered.map((x) => {
            return <li>{x}</li>;
          })}
        </ul>
      </Flex>
      {!!isShowDoc && (
        <Modal isOpen={isShowDoc} onBackgroundClick={handleClose} onEscapeKeydown={handleClose}>
          {/* <SpecialModalBackground> */}
          <Box
            style={{
              margin: '0 auto',
              alignSelf: 'center',
              borderRadius: '20px',
              position: 'relative',
              backgroundColor: 'white',
              padding: '0',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '100%',
              maxHeight: '100%',
              width: '100%',
              maxWidth: '100%',
            }}
          >
            <LabOrderHiddenForm encounterId={lab.encounterId} onClose={handleClose} />
            {/* <LabDocumentViewer doc={lab.results.pdf} /> */}
            {/* <Flex flexDirection={'row'} justifyContent="space-between" width={'100%'}>
              <Button variant={'primary'} onClick={handleClose} mt={4}>
                Close
              </Button>
            </Flex> */}
          </Box>
          {/* </SpecialModalBackground> */}
        </Modal>
      )}
    </>
  );
};

const Content = ({ lab, date, canViewDoc }) => {
  return <ContentResults lab={lab} date={date} canViewDoc={canViewDoc} />;
};
const Wrap = styled(Flex)`
  max-height: '';
  @media screen and (min-width: 52em) {
    max-height: ${(props) => (!props.showTrend ? `calc(100vh - 90px)` : '')};
  }
`;

const LabOrders = ({ ...props }) => {
  const {
    session: { labCenter },
    history,
  } = props;
  const [showTrend, setShowTrend] = useState(false);
  const [isMobileSize, setIsMobileSize] = useState(null);

  useEffect(() => {
    if (window.innerWidth > 425) {
      setIsMobileSize(false);
    } else {
      setIsMobileSize(true);
    }

    const updateMedia = () => {
      if (window.innerWidth > 425) {
        setIsMobileSize(false);
      } else {
        setIsMobileSize(true);
      }
    };
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  return (
    <Flex flexDirection={'column'} width={'100%'} height="100%" maxHeight={'100%'} style={{ overflow: 'hidden' }}>
      <Query query={GET_LAB_ORDERS_LIST}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <Flex flex={1} justifyContent="center" alignItems="center">
                <SpinLoader />
              </Flex>
            );
          }

          if (error) {
            return (
              <Flex flex={1} justifyContent="center" alignItems="center">
                <Text fontSize={5} fontWeight={600} textAlign="center">
                  Unable to retrieve lab tests. Please try again.
                </Text>
              </Flex>
            );
          }

          const { getLabOrdersReady } = data;
          const selected = !props.match.isExact ? 'selected' : null;
          const labs = getLabOrdersReady;

          if (!labs || labs.length === 0) {
            return null; // <EmptyState {...props} />;
          }
          let age = 0;
          if (props.session && props.session.dob) {
            age = moment().diff(moment(props.session.dob, 'MM/DD/YYYY'), 'year');
          }
          return (
            <Wrap flex={1} flexDirection={'column'} overflowY={['auto', !showTrend ? 'hidden' : 'auto']} showTrend={showTrend}>
              <Flex flexDirection={['column', 'row']} p={['16px', 4]} style={{ borderBottom: '1px solid rgba(52, 79, 122, 0.19)' }} alignItems={['flex-start', 'center']}>
                <FlexMobile flex={1} width={'100%'} mb={3}>
                  <Flex flex={1}>
                    <Flex
                      style={{ display: !showTrend ? 'flex' : 'none' }}
                      onClick={() => {
                        setShowTrend(true);
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M3 15V16.8C3 17.92 3 18.48 3.218 18.908C3.40974 19.2843 3.71569 19.5903 4.092 19.782C4.519 20 5.079 20 6.197 20H21M3 15V5M3 15L6.853 11.79L6.857 11.787C7.554 11.206 7.903 10.915 8.282 10.797C8.72913 10.6572 9.21116 10.6788 9.644 10.858C10.011 11.011 10.332 11.332 10.976 11.976L10.982 11.982C11.636 12.636 11.963 12.964 12.336 13.115C12.7774 13.2949 13.2686 13.3112 13.721 13.161C14.104 13.033 14.454 12.727 15.154 12.115L21 7"
                          stroke="#657AA4"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <Text ml={3} style={{ color: '#657AA4' }}>
                        Lab Orders
                      </Text>
                    </Flex>
                  </Flex>
                </FlexMobile>
                <Text fontSize={'20px'} fontWeight={'600'} mr={4} mb={[2, 0]} textAlign={'left'}>
                  Your Lab Orders
                </Text>
              </Flex>

              {age >= 25 && (
                <Card
                  style={{ backgroundColor: '#E7F0FF', border: '1px solid #354E79', borderRadius: '10px', flex: 'initial', marginLeft: '16px', marginRight: '16px' }}
                  mb={'32px'}
                  mt={'32px'}
                >
                  <Flex style={{ overflow: 'hidden', padding: '12px 8px' }} alignItems={'center'}>
                    <Flex flexDirection={'column'} ml={3}>
                      <Flex alignItems={'center'}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M22.2 17.6334L14.0016 3.39563C13.7967 3.04681 13.5042 2.75758 13.1532 2.55662C12.8021 2.35566 12.4046 2.24994 12 2.24994C11.5955 2.24994 11.198 2.35566 10.8469 2.55662C10.4958 2.75758 10.2033 3.04681 9.99847 3.39563L1.80003 17.6334C1.60291 17.9708 1.49902 18.3546 1.49902 18.7453C1.49902 19.1361 1.60291 19.5198 1.80003 19.8572C2.00228 20.2081 2.29425 20.4989 2.64599 20.6997C2.99773 20.9006 3.39658 21.0042 3.80159 21H20.1985C20.6032 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.9961 20.2078 22.1982 19.8572C22.3956 19.52 22.4998 19.1363 22.5001 18.7456C22.5004 18.3548 22.3969 17.971 22.2 17.6334ZM20.8997 19.1063C20.8282 19.2282 20.7256 19.3289 20.6024 19.3981C20.4792 19.4673 20.3398 19.5024 20.1985 19.5H3.80159C3.66029 19.5024 3.52088 19.4673 3.39765 19.3981C3.27442 19.3289 3.17181 19.2282 3.10034 19.1063C3.0356 18.9966 3.00145 18.8717 3.00145 18.7444C3.00145 18.6171 3.0356 18.4921 3.10034 18.3825L11.2988 4.14469C11.3717 4.02335 11.4748 3.92295 11.598 3.85324C11.7212 3.78354 11.8603 3.7469 12.0019 3.7469C12.1435 3.7469 12.2826 3.78354 12.4058 3.85324C12.529 3.92295 12.6321 4.02335 12.705 4.14469L20.9035 18.3825C20.9676 18.4924 21.0011 18.6176 21.0005 18.7449C20.9998 18.8722 20.965 18.997 20.8997 19.1063ZM11.25 13.5V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6104 9.07902 11.8011 9 12 9C12.1989 9 12.3897 9.07902 12.5304 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V13.5C12.75 13.6989 12.671 13.8897 12.5304 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6104 14.171 11.4697 14.0303C11.329 13.8897 11.25 13.6989 11.25 13.5ZM13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7806 17.9784C11.5623 17.935 11.3619 17.8278 11.2045 17.6705C11.0472 17.5132 10.9401 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9607 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875Z"
                            fill="#344f79"
                          />
                        </svg>
                        <Text fontSize={'16px'} fontWeight={700} ml={3}>
                          Important Notice for Medicare Patients Only
                        </Text>
                      </Flex>
                      <Text fontSize={'14px'} mt="12px">
                        Our providers are not enrolled in Medicare, which means any lab orders from our doctors may not be covered by Medicare. You may need to pay for these labs out of pocket. If you
                        prefer to have these labs covered by Medicare, we recommend asking your primary care provider to order them instead.
                      </Text>
                    </Flex>
                  </Flex>
                </Card>
              )}
              <Flex flex={1} style={{ overflowY: 'auto' }}>
                {!labCenter && (
                  <Card style={{ width: '100%', maxWidth: '700px', backgroundColor: '#FFD5C6', border: '1px solid #FFA482', borderRadius: '10px' }} mb={'32px'}>
                    <Flex style={{ overflow: 'hidden', padding: '12px 8px' }} alignItems={'center'}>
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M22.2 17.6334L14.0016 3.39563C13.7967 3.04681 13.5042 2.75758 13.1532 2.55662C12.8021 2.35566 12.4046 2.24994 12 2.24994C11.5955 2.24994 11.198 2.35566 10.8469 2.55662C10.4958 2.75758 10.2033 3.04681 9.99847 3.39563L1.80003 17.6334C1.60291 17.9708 1.49902 18.3546 1.49902 18.7453C1.49902 19.1361 1.60291 19.5198 1.80003 19.8572C2.00228 20.2081 2.29425 20.4989 2.64599 20.6997C2.99773 20.9006 3.39658 21.0042 3.80159 21H20.1985C20.6032 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.9961 20.2078 22.1982 19.8572C22.3956 19.52 22.4998 19.1363 22.5001 18.7456C22.5004 18.3548 22.3969 17.971 22.2 17.6334ZM20.8997 19.1063C20.8282 19.2282 20.7256 19.3289 20.6024 19.3981C20.4792 19.4673 20.3398 19.5024 20.1985 19.5H3.80159C3.66029 19.5024 3.52088 19.4673 3.39765 19.3981C3.27442 19.3289 3.17181 19.2282 3.10034 19.1063C3.0356 18.9966 3.00145 18.8717 3.00145 18.7444C3.00145 18.6171 3.0356 18.4921 3.10034 18.3825L11.2988 4.14469C11.3717 4.02335 11.4748 3.92295 11.598 3.85324C11.7212 3.78354 11.8603 3.7469 12.0019 3.7469C12.1435 3.7469 12.2826 3.78354 12.4058 3.85324C12.529 3.92295 12.6321 4.02335 12.705 4.14469L20.9035 18.3825C20.9676 18.4924 21.0011 18.6176 21.0005 18.7449C20.9998 18.8722 20.965 18.997 20.8997 19.1063ZM11.25 13.5V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6104 9.07902 11.8011 9 12 9C12.1989 9 12.3897 9.07902 12.5304 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V13.5C12.75 13.6989 12.671 13.8897 12.5304 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6104 14.171 11.4697 14.0303C11.329 13.8897 11.25 13.6989 11.25 13.5ZM13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7806 17.9784C11.5623 17.935 11.3619 17.8278 11.2045 17.6705C11.0472 17.5132 10.9401 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9607 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875Z"
                          fill="#344f79"
                        />
                      </svg>

                      <Flex flexDirection={'column'} ml={3}>
                        <Text fontSize={'16px'} fontWeight={700}>
                          Select Your Preferred Lab Center
                        </Text>
                        <Text fontSize={'14px'} mt="12px">
                          Please indicate your preferred lab location
                        </Text>
                      </Flex>

                      <Button variant={'primary'} onClick={() => history.push('/lab-center')}>
                        Select Lab
                      </Button>
                    </Flex>
                  </Card>
                )}
                <VerticalTimeline layout="1-column" lineColor="#344F7A">
                  {labs
                    .sort((a, b) => {
                      const dateA = moment(a.createdOn);
                      const dateB = moment(b.createdOn);

                      if (dateA < dateB) return 1;
                      if (dateA > dateB) return -1;

                      return 0;
                    })
                    .map((x) => {
                      return (
                        // {timelineElements}
                        <VerticalTimelineElement
                          className="vertical-timeline-element--work"
                          contentStyle={{ background: 'white' }}
                          date={moment(x.createdOn).format('DD MMM YYYY')}
                          iconStyle={iconStyle}
                          icon={<div />}
                        >
                          {/* <NavLink to={`/labs/p/${x.id}`}> */}
                          <>
                            <Content lab={x} date={`${moment(x.createdOn).format('DD MMM YYYY')}`} canViewDoc={!!labCenter} />
                            {!!labCenter && (
                              <svg
                                style={{ position: 'absolute', right: '-20px', top: '40%', cursor: 'pointer' }}
                                className="RArr"
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="24"
                                viewBox="0 0 11 24"
                                fill="none"
                              >
                                <path
                                  d="M0.295606 2.02351C0.20118 1.90901 0.12736 1.77433 0.078361 1.62714C0.0293618 1.47995 0.0061425 1.32314 0.0100301 1.16567C0.0139177 1.0082 0.0448356 0.853153 0.101018 0.709374C0.157201 0.565596 0.237548 0.435905 0.337472 0.327707C0.437396 0.219508 0.554941 0.134922 0.683394 0.078776C0.811848 0.0226304 0.948694 -0.00397488 1.08612 0.000479721C1.22355 0.00493432 1.35886 0.0403613 1.48434 0.104738C1.60982 0.169115 1.723 0.26118 1.81743 0.375678L10.7139 11.1693C10.8976 11.392 11 11.6868 11 11.9933C11 12.2997 10.8976 12.5945 10.7139 12.8172L1.81743 23.612C1.72362 23.729 1.61047 23.8235 1.48453 23.89C1.35859 23.9565 1.22238 23.9936 1.08381 23.9992C0.945238 24.0049 0.80707 23.9789 0.677332 23.9229C0.547593 23.8668 0.428869 23.7818 0.328055 23.6727C0.227242 23.5636 0.146348 23.4326 0.0900744 23.2874C0.0338003 23.1422 0.00326716 22.9857 0.000248143 22.8268C-0.00277087 22.668 0.0217842 22.51 0.0724878 22.3622C0.123192 22.2143 0.199033 22.0794 0.295606 21.9654L8.51386 11.9933L0.295606 2.02351Z"
                                  fill="#4E658A"
                                />
                              </svg>
                            )}
                          </>
                          {/* </NavLink> */}
                        </VerticalTimelineElement>
                      );
                    })}
                </VerticalTimeline>
              </Flex>
              <DetailContainer
                flex={1}
                justifyContent="center"
                className={selected}
                onClick={() => {
                  props.history.goBack();
                }}
              >
                <Inner
                  flex={1}
                  flexDirection="column"
                  pt={[0, 0, 3]}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <div>
                    <BackButtonDesktop>
                      <svg
                        onClick={() => props.history.goBack()}
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ transform: 'rotate(180deg)', cursor: 'pointer' }}
                      >
                        <path d="M21.3337 8.33335L31.3337 20L21.3337 31.6667" stroke="#4E658A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M11.6667 8.33335L21.6667 20L11.6667 31.6667" stroke="#4E658A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </BackButtonDesktop>
                    <BackButton onClick={() => props.history.goBack()}>{'<  Your Lab Results'}</BackButton>
                  </div>
                  {/* 
                  <Route path="/labs/p/:id" component={(props) => <LabDetail labs={labs} {...props} isDiagnosed={isDiagnosed} />} />
                  <Route path="/labs/r/:id" component={(props) => <LabDetailReleased labs={labs} {...props} isDiagnosed={isDiagnosed} />} /> */}
                </Inner>
              </DetailContainer>
            </Wrap>
          );
        }}
      </Query>
      <Flex id={'testRightPane'} style={{}} />
    </Flex>
  );
};

export default withRouter(withSession(LabOrders));
